import { Box, Popover } from "@mui/material";
import { useEffect, useState } from "react";
import { useBodyBackdrop } from "./useBodyBackdrop";
import AspectClearableLabel from "./AspectClearableLabel";

export default function AspectMenu({
  label,
  selectedValues,
  icon,
  body,
  onClear,
  target,
  onOpen,
}: {
  label: string;
  selectedValues?: string[];
  icon: React.ReactNode;
  body: (handleClose: () => void) => React.ReactNode;
  onClear?: () => void;
  target?: React.ReactNode;
  onOpen?: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { backdropOpen, setBackdropOpen } = useBodyBackdrop();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setBackdropOpen(true);
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setBackdropOpen(false);
  };

  useEffect(() => {
    if (!backdropOpen) {
      setAnchorEl(null);
    }
  }, [backdropOpen]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box>
      {target ? (
        <Box onClick={handleClick}>{target}</Box>
      ) : (
        <AspectClearableLabel
          icon={icon}
          label={label}
          selectedValues={selectedValues}
          onClear={onClear}
          onClick={handleClick}
        />
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          root: {
            sx: {
              // maxHeight: "calc(100vh - 270px)",
            },
          },
        }}
      >
        {body(handleClose)}
      </Popover>
    </Box>
  );
}
